import { track } from '../../utils/analytics'

const PAGE = 'ai-transformation'

const DEMO_SOURCE_STORAGE_KEY = 'ai_transformation_demo_source'

export function trackSectionViewed(section: string, index: number) {
  track({
    eventName: 'WEBSITE_SECTION_VIEWED',
    eventData: { page: PAGE, section, index },
  })
}

export function trackDemoFormOpen(source: string) {
  track({
    eventName: 'WEBSITE_DEMO_FORM_OPENED',
    eventData: { page: PAGE, source },
  })
  try {
    sessionStorage.setItem(
      DEMO_SOURCE_STORAGE_KEY,
      JSON.stringify({ page: PAGE, source })
    )
  } catch {
    // Storage unavailable (private mode) — the open event still fired.
  }
}

// Read by the /book-demo form to attribute demo bookings back to the landing
// page that funneled the visitor there.
export function readDemoSource(): { page: string; source: string } | null {
  try {
    const parsed: unknown = JSON.parse(
      sessionStorage.getItem(DEMO_SOURCE_STORAGE_KEY) || 'null'
    )
    if (
      parsed &&
      typeof parsed === 'object' &&
      'page' in parsed &&
      'source' in parsed
    ) {
      return parsed as { page: string; source: string }
    }
  } catch {}
  return null
}
